import { useQuery } from '@tanstack/react-query';
import { getOperationPackagePatterns, getOperationPackages, postOperationPackagePatterns } from '@/features/operation-packages/api';
import { PACKAGE_TYPE_TO_GROUP } from '../-constants';
import type { ItOperationCorePackages } from './type';

// グルーピングロジックを含むAPI実装
export async function listOperationPackages(): Promise<ItOperationCorePackages> {
  const packages = await getOperationPackages('IT_OPERATION_CORE');
  const mappedPackages = packages.map(pkg => ({
    id: pkg.operationPackageId,
    type: pkg.packageType,
    name: pkg.name,
    description: pkg.description ?? undefined
  }));

  // グルーピング
  const result: ItOperationCorePackages = {
    apps: [],
    devices: [],
    sharedDrive: [],
    network: []
  };
  for (const pkg of mappedPackages) {
    const group = PACKAGE_TYPE_TO_GROUP[pkg.type];
    if (group) {
      result[group].push(pkg);
    }
    // マッピングがないものは無視
  }
  return result;
}
export function useItOperationPackages() {
  return useQuery({
    queryKey: ['it-operation-packages'],
    queryFn: listOperationPackages
  });
}
export function listPackagePatterns(packageId: string) {
  return getOperationPackagePatterns('IT_OPERATION_CORE', packageId);
}
export function createPattern(packageId: string) {
  return postOperationPackagePatterns('IT_OPERATION_CORE', packageId);
}
export function createPatternManual(packageId: string, body: {
  name: string;
  description?: string;
}) {
  return postOperationPackagePatterns('IT_OPERATION_CORE', packageId, body);
}